import { Faqs, Pros } from 'context/page-form-context';

import {
  AiVariant,
  AiVariantComment,
  AiVariantCommentMap,
  AiVariantMap,
  MelFields,
} from '../types';

export const mapVariants = (
  pageVariants?: AiVariant[],
  productVariants?: AiVariant[],
): AiVariantMap => {
  const map: AiVariantMap = {
    [MelFields.BottomLine]: [],
    [MelFields.BuyingGuide]: [],
    [MelFields.Faqs]: [],
    [MelFields.Pros]: [],
    [MelFields.Summary]: [],
  };

  if (pageVariants) {
    pageVariants.forEach((variant) => {
      map[variant.field_name as keyof AiVariantMap] = [
        ...map[variant.field_name as keyof AiVariantMap],
        variant,
      ];
    });
  }

  if (productVariants) {
    productVariants.forEach((variant) => {
      if (Object.values(MelFields).includes(variant.field_name as any)) {
        map[variant.field_name as keyof AiVariantMap] = [
          ...map[variant.field_name as keyof AiVariantMap],
          variant,
        ];
      }
    });
  }

  return map;
};

export const convertFaqsToContext = (faqs: Faqs) => {
  const deps: Record<string, string[]> = {};

  faqs.forEach((faq) => {
    deps[faq.question] = [faq.answer];
  });

  return deps;
};

export const convertValueToPros = (value: string): Pros => {
  return value
    .split('- ', 4)
    .filter((item) => item !== '')
    .map((item) => item.trim().replace(' /n', ''));
};

export const convertValueToFaqs = (values: string): Faqs => {
  return Object.entries(JSON.parse(values)).map(([key, value]) => ({
    answer: value as string,
    question: key,
  }));
};

export const mapContextHistory = (contextHistory?: AiVariantComment[], entityId?: number) => {
  const deps: AiVariantCommentMap = {};

  const history =
    entityId && contextHistory
      ? contextHistory.filter((item) => item.entity_id === entityId)
      : contextHistory ?? [];

  history.forEach((item) => {
    deps[item.field_name] = deps[item.field_name] ? [...deps[item.field_name], item] : [item];
  });

  return deps;
};
